import AbsComponent from "../../common/AbsComponent";

/**
 * CardList class
 * @category main
 */
class CardList extends AbsComponent{
    constructor(_store={}, _el='', _key){
        super(_store, _el);

        this.charServerType = this.store.data.config.charServerType;
        this.store.getData( _key , {}, this.render.bind(this));

        // this.store.getData('mainCardlist1', {}, this.render.bind(this));
        // this.store.getData('mainCardlist2', {}, this.render.bind(this));
        // this.store.getData('mainCardlist3', {}, this.render.bind(this));
        // this.store.getData('mainCardlist4', {}, this.render.bind(this));
        // this.store.getData('mainCardlist5', {}, this.render.bind(this));
        // this.store.getData('mainCardlist6', {}, this.render.bind(this));
    }

    render(_jsonData = {}) {
        // console.log('render cardList ----->', _jsonData);
        $(this.el).replaceWith(this.template( _jsonData ));
        this.setting();
    }

    template(_d={}) {
        let templ = ''; //템플릿
        let templList = ''; //서버별 아이템 템플릿
        let itemOrder = []; //서버별 아이템 노출 순서

        _d = JSON.parse(_d.jsonData);

        if ( ! _d.visible) return false;

        // 아이템 노출 순서
        if (this.charServerType == "lineage2") {
            itemOrder = _d.orderDefault.split(',')
        } else if (this.charServerType == "lineage2Awakening") {
            itemOrder = _d.orderAwken.split(',')
        } else {
            itemOrder = _d.orderOther.split(',')
        }
        // 리스트
        itemOrder.forEach(function(n) {
            templList += `
               <li class="card-item">
                  <a href="${_d.items[n-1].url}" class="card-item-link">
                      <div class="item-thumb" style="background-image: url('${_d.items[n-1].thumbnail}')"></div>
                      <div class="item-info">
                        ${_d.items[n-1].labelText != "" ? `<em class="item-info-tag ${_d.items[n-1].labelType}">${_d.items[n-1].labelText}</em>` :``}
                          <strong class="item-info-title">${_d.items[n-1].title}</strong>
                          <p class="item-info-text">${_d.items[n-1].desc}</p>
                      </div>
                  </a>
              </li>
            `
        })

        templ = `
            <div class="card-list-wrap ${_d.contentsType}">
              <h2 class="card-list-title">${_d.header}</h2>
              <ul class="card-list">
              ${templList}
              </ul>
            </div>
        `;
        return templ;

    }

    setting(){
        const slickOption = {
            dots: true,
            infinite: false,
            autoplay: false,
            arrows: false,
            autoplaySpeed: 5000,
            responsive: [
                {
                    breakpoint: 4000,
                    settings: "unslick"
                },
                {
                    breakpoint: 960,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                }
            ]
        };

        $('.card-list-wrap.is-6items .card-list').slick(slickOption);

        window.addEventListener("resize", ()=>{
            if(window.innerWidth < 960 && $('.card-list-wrap.is-6items .card-list').slick('getSlick').unslicked) {
                $('.card-list-wrap.is-6items .card-list').slick(slickOption);
            }
        });
    }
} // end of class
export default CardList;